module.exports = __webpack_public_path__ + "img/spacer-icon.ce6a5c8b.svg";